import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import MostReadItem, { MostReadContainer }
from '@fuww/library/src/List/MostRead';
import HiddenLoader from '@fuww/library/src/HiddenLoader';
import withQuery from '../../../lib/withQuery';
import MostReadList from './MostReadList';
import articlesQuery from '../../../lib/queries/news/articlesQuery.graphql';
import getNewsboardFieldVariables
from '../../../lib/queries/getNewsboardFieldVariables';
import getArticlesField from '../../../lib/queries/news/getArticlesField';
import { newsListImageConfigurations }
from '../../../lib/imageConfigurations';
import mainCategoryIds from '../../../lib/mainCategoryIds';
import { useSiteContext } from '../../SiteContext';
import messages from '../../../lib/messages.mjs';

const MostRead = ({
  data,
  field,
  noBorderFirstItem,
  showLoader,
  loading,
}) => {
  const articles = data[field];
  const intl = useIntl();

  const hasData = !loading && Array.isArray(articles) && articles.length > 0;

  if (loading && !hasData) {
    return (
      <MostReadContainer
        title={intl.formatMessage(messages.mostRead)}
      >
        {Array.from({ length: 6 }, (_, index) => index).map((_, index) => (
          <MostReadItem
            // eslint-disable-next-line react/no-array-index-key
            key={`skeleton-${index}`}
            showLoader
            number={index + 1}
            title=""
          />
        ))}
      </MostReadContainer>
    );
  }

  return articles.length > 0 && (
  <MostReadContainer
    title={intl.formatMessage(messages.mostRead)}
  >
    <MostReadList
      showLoader={showLoader}
      newsArticles={articles}
      noBorderFirstItem={noBorderFirstItem}
      showImage
      showCategory
    />
  </MostReadContainer>
  );
};

MostRead.propTypes = {
  data: PropTypes.shape({}),
  field: PropTypes.string.isRequired,
  noBorderFirstItem: PropTypes.bool,
  showLoader: PropTypes.bool,
  loading: PropTypes.bool,
};

MostRead.defaultProps = {
  data: {},
  noBorderFirstItem: null,
  showLoader: false,
  loading: false,
};

const MostReadWithQuery = withQuery(MostRead, { renderAlways: true });

const errorMessage = 'Error while loading news articles...';

const MostReadWithData = ({
  noBorderFirstItem,
}) => {
  const {
    prefix, hasLocalNews, newsboard,
  } = useSiteContext();

  const field = getArticlesField(prefix, hasLocalNews);
  const variables = {
    ...getNewsboardFieldVariables(prefix, hasLocalNews),
    withoutDescriptionAndCreator: true,
    withoutSummaryAndLabel: true,
    categoryIds: mainCategoryIds,
    imageConfigurations: newsListImageConfigurations,
    inDays: 5,
    limit: 6,
    newsboards: [newsboard],
    sort: 'POPULARITY',
  };

  return (
    <MostReadWithQuery
      query={articlesQuery}
      variables={variables}
      errorMessage={errorMessage}
      field={field}
      noBorderFirstItem={noBorderFirstItem}
      loader={<HiddenLoader />}
    />
  );
};

MostReadWithData.propTypes = {
  noBorderFirstItem: PropTypes.bool,
};

MostReadWithData.defaultProps = {
  noBorderFirstItem: null,
};

export default MostReadWithData;
